<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells position="between">
        <app-cells :indent="false">
          <h1
            @click="onCopyToClipboard(`${form.airline.name} (#${$route.params.id})`)"
            class="title"
            style="cursor: pointer"
          >
            {{ form.airline.name }} (#{{ $route.params.id }})
          </h1>
          <div v-if="form.lead.reservation_manager" class="manager-title">
            <div class="manager-title__photo">
              <img :src="getUserAvatar(form.lead.reservation_manager.crop.crop_url)" alt="Avatar">
            </div>
            <span class="manager-title__name">{{ form.lead.reservation_manager.full_name }}</span>
          </div>
          <app-option-picker
            @click="onOptionSelected($event, true)"
            v-model="form.reservation_status"
            :options="form.available_reservation_statuses"
            :disable="form.available_reservation_statuses.length < 1 || (!is_general_manager && !is_reservations_department)"
          />
          <div v-if="form.lead" class="manager-title">
            <div class="manager-title__photo">
              <img :src="getUserAvatar(form.lead.manager.crop.crop_url)" alt="Avatar">
            </div>
            <span class="manager-title__name">{{ form.lead.manager.full_name }}</span>
          </div>
          <app-option-picker
            @click="onOptionSelected($event, false)"
            v-model="form.sales_status"
            :options="form.available_sales_statuses"
            :disable="form.available_sales_statuses.length < 1 || (!is_general_manager && !is_sales_manager && !is_sales_supervisor)"
          />
        </app-cells>
        <app-cells v-if="is_general_manager || is_super_user" :indent="false">
          <app-button
            v-if="is_general_manager"
            @click.native="$modal.show('accept-delete-res')"
            size="small"
            theme="error"
          >
            Delete
          </app-button>
          <a
            v-if="is_super_user"
            :href="`${admin_url}reservations/flight/${$route.params.id}/change/`"
            target="_blank"
            class="btn btn--blue btn--small"
          >
            Django
          </a>
        </app-cells>
      </app-cells>
      <app-cells>
        <router-link
          :to="{ name: 'leads-detail-reservations', params: { id: form.lead.id } }"
          style="color: #5f5f5f"
        >
          {{ form.lead.name ? `Main guest: ${form.lead.name}` : `Lead #${form.lead?.id}` }}
        </router-link>
      </app-cells>
      <app-info-text-panel v-if="form.already_booked && form.reservation_status.code !== 'booked'">
        Sales manager marked this reservation as already booked. Check asana and fill data properly
      </app-info-text-panel>

      <app-page-container>
        <!-- TOP -- Cancellation actions ---------------------->
        <template v-if="form.cancellation_request">
          <app-cells>
            <h3 v-if="is_reservations_department" class="title">What did the hotel answer regarding the cancellation?</h3>
            <h3 v-else class="title">Cancellation actions</h3>
            <app-button
              @click.native="onOpenSendEmailPopup('cancellation')"
              size="small"
            >
              Resend email
            </app-button>
            Reservation status:
            <app-option-picker
              @click="onCancellationOptionSelected($event, true)"
              v-model="form.cancellation_request.reservation_status"
              :options="form.cancellation_request.available_reservation_statuses"
              :disable="form.cancellation_request.available_reservation_statuses < 1 || (!is_general_manager && !is_reservations_department)"
              :amount="form.cancellation_request.amount || null"
            />
            Sales status:
            <app-option-picker
              @click="onCancellationOptionSelected($event, false)"
              v-model="form.cancellation_request.sales_status"
              :options="form.cancellation_request.available_sales_statuses"
              :disable="form.cancellation_request.available_sales_statuses < 1 || (!is_general_manager && !is_reservations_department)"
            />
          </app-cells>
          <app-colored-notes
            v-if="is_reservations_department && form.cancellation_request.notes"
            color="#77b017"
            :text="form.cancellation_request.notes"
          />
          <app-form-group
            v-if="!is_reservations_department"
            label="Sales manager notes for hotel cancellation"
            label-for="notes"
            :style="{ maxWidth: '1080px' }"
          >
            <app-textarea
              @change.native="onPatchReservationCancellationNotes"
              v-model="form.cancellation_request.notes"
              rows="5"
              placeholder="Write a note"
              id="notes"
              :readonly="!is_general_manager && !is_sales_manager && !is_sales_supervisor"
            />
          </app-form-group>
        </template>
        <!--------------------- BOTTOM /// Cancellation actions /// -->

        <!-- TOP -- Amendment actions ---------------------->
        <template v-if="form.amendment_request">
          <app-cells>
            <h3 v-if="is_reservations_department" class="title">What did the hotel answer regarding the amendment?</h3>
            <h3 v-else class="title">Amendment actions</h3>
            <app-button
              v-if="is_general_manager || is_reservations_department"
              @click.native="onOpenSendEmailPopup('amendment')"
              size="small"
            >
              Resend email
            </app-button>
            Reservation status:
            <app-option-picker
              @click="onAmendmentOptionSelected($event, true)"
              v-model="form.amendment_request.reservation_status"
              :options="form.amendment_request.available_reservation_statuses"
              :disable="form.amendment_request.available_reservation_statuses < 1 || (!is_general_manager && !is_reservations_department)"
              :amount="form.amendment_request.amount || null"
            />
            Sales status:
            <app-option-picker
              @click="onAmendmentOptionSelected($event, false)"
              v-model="form.amendment_request.sales_status"
              :options="form.amendment_request.available_sales_statuses"
              :disable="form.amendment_request.available_sales_statuses < 1 || (!is_general_manager && !is_reservations_department)"
            />
          </app-cells>
          <app-colored-notes
            v-if="is_reservations_department && form.amendment_request.notes"
            color="#77b017"
            :text="form.amendment_request.notes"
          />
          <app-form-group
            v-if="!is_reservations_department"
            label="Sales manager notes for hotel amendment"
            label-for="notes"
          >
            <app-textarea
              @change.native="onPatchReservationAmendmentNotes"
              v-model="form.amendment_request.notes"
              rows="5"
              placeholder="Write a note"
              id="notes"
              :readonly="!is_general_manager && !is_sales_manager && !is_sales_supervisor"
            />
          </app-form-group>
        </template>
        <!--------------------- BOTTOM /// Amendment actions /// -->

        <template v-if="!form.cancellation_request && !form.amendment_request">
          <app-colored-notes v-if="is_reservations_department && form.notes" color="#77b017" :text="form.notes" />
          <app-form-group
            v-if="!is_reservations_department"
            label="Sales manager notes for the airline"
            label-for="notes"
          >
            <app-textarea
              @change.native="onPatchReservationNotes"
              v-model="form.notes"
              rows="5"
              placeholder="Write a note"
              id="notes"
              :readonly="(!is_general_manager && !is_sales_manager && !is_sales_supervisor) && form.reservation_status.code === 'booked'"
            />
          </app-form-group>
        </template>
        <app-cells v-if="
        (is_general_manager || is_sales_manager || is_sales_supervisor) &&
        (form.reservation_status.code === 'booked' || form.reservation_status.code === 'booked_provisionally') &&
        !form.cancellation_request && !form.amendment_request
      ">
          <app-button
            @click.native="onShowRequestAmendmentsModal"
            theme="warn"
          >
            Amendment
          </app-button>
          <app-button
            @click.native="$modal.show('accept-request-cancellation-modal')"
            theme="error"
          >
            Cancellation
          </app-button>
        </app-cells>

        <app-grid v-if="form.amendment_request">
          <template #item-1>
            <h3 class="title reservation-grid__title" style="color: #008000">The new requirements for the booking</h3>
            <div class="k-v">
              <div class="k-v__item">
                <span class="k-v__k">Date:</span>&nbsp;<span class="k-v__v">{{ formatDate(form.amendment_request.date) }}</span>
              </div>
              <app-cells :indent="false">
                <div class="k-v__item">
                  <span class="k-v__k">Origin:</span>&nbsp;<span class="k-v__v">{{ form.amendment_request.origin.name }}</span>
                </div>
                <div class="k-v__item">
                  <span class="k-v__k">Departure:</span>&nbsp;<span class="k-v__v">{{ form.amendment_request.departure }}</span>
                </div>
              </app-cells>
              <app-cells :indent="false">
                <div class="k-v__item">
                  <span class="k-v__k">Destination:</span>&nbsp;<span class="k-v__v">{{ form.amendment_request.destination.name }}</span>
                </div>
                <div class="k-v__item">
                  <span class="k-v__k">Arrival:</span>&nbsp;<span class="k-v__v">{{ form.amendment_request.arrival }}</span>
                </div>
              </app-cells>
            </div>
            <app-lug-item
              v-for="(seat, seat_index) in form.amendment_request.short_seats"
              :key="`lug_${seat_index}`"
              :order-number="seat_index + 1"
              :age-type="seat.luggage_option.age_type"
              :weight="seat.luggage_option.weight"
              :count="seat.count"
              :seats-assignment="true"
              :deleted="false"
            />
          </template>
          <template #item-2>
            <h3 class="title reservation-grid__title" style="color: #993300">The details of the original booking</h3>
            <div class="k-v">
              <div class="k-v__item">
                <span class="k-v__k">Date:</span>&nbsp;<span class="k-v__v">{{ formatDate(form.date) }}</span>
              </div>
              <app-cells :indent="false">
                <div class="k-v__item">
                  <span class="k-v__k">Origin:</span>&nbsp;<span class="k-v__v">{{ form.origin.name }}</span>
                </div>
                <div class="k-v__item">
                  <span class="k-v__k">Departure:</span>&nbsp;<span class="k-v__v">{{ form.departure }}</span>
                </div>
              </app-cells>
              <app-cells :indent="false">
                <div class="k-v__item">
                  <span class="k-v__k">Destination:</span>&nbsp;<span class="k-v__v">{{ form.destination.name }}</span>
                </div>
                <div class="k-v__item">
                  <span class="k-v__k">Arrival:</span>&nbsp;<span class="k-v__v">{{ form.arrival }}</span>
                </div>
              </app-cells>
            </div>
            <app-lug-item
              v-for="(seat, seat_index) in form.seats_short"
              :key="`lug_${seat_index}`"
              :order-number="seat_index + 1"
              :age-type="seat.luggage_option.age_type"
              :weight="seat.luggage_option.weight"
              :count="seat.count"
              :seats-assignment="true"
              :deleted="false"
            />
          </template>
        </app-grid>
        <template v-else>
          <h3 v-if="is_general_manager && !form.seats_assignment" class="title title--mb15">Flight configuration</h3>
          <app-flex-grid :rows="[['130px', 1, '70px', 1, '70px']]">
            <template #col-1-1>
              <app-form-group label="Date" class="form-group--no-indent" required>
                <app-date-picker
                  v-model="form.date"
                  placeholder="Date"
                  :readonly="!is_general_manager || form.seats_assignment"
                  :error="$v.form.date.$error"
                />
                <template #error>
                  <div v-if="$v.form.date.$dirty && !$v.form.date.required">Required field</div>
                </template>
              </app-form-group>
            </template>
            <template #col-1-2>
              <app-form-group label="Origin" class="form-group--no-indent" required>
                <app-select
                  v-model="form.origin"
                  :options="form.airline.airstrips"
                  :clearable="false"
                  placeholder="Choose origin"
                  :readonly="!is_general_manager || form.seats_assignment"
                  :error="$v.form.origin.$error"
                />
                <template #error>
                  <div v-if="$v.form.origin.$dirty && !$v.form.origin.required">Required field</div>
                </template>
              </app-form-group>
            </template>
            <template #col-1-3>
              <app-form-group label="Departure" class="form-group--no-indent" required>
                <app-input
                  v-model="form.departure"
                  v-mask="'99:99'"
                  placeholder="00:00"
                  autocomplete="off"
                  id="time"
                  name="time"
                  @paste.native.prevent
                  :readonly="!is_general_manager || form.seats_assignment"
                  :error="$v.form.departure.$error"
                />
                <template #error>
                  <div v-if="$v.form.departure.$dirty && !$v.form.departure.timeRegex">Wrong time</div>
                  <div v-if="$v.form.arrival.$dirty && !$v.form.arrival.required">Required field</div>
                </template>
              </app-form-group>
            </template>
            <template #col-1-4>
              <app-form-group label="Destination" class="form-group--no-indent" required>
                <app-select
                  v-model="form.destination"
                  :options="form.airline.airstrips"
                  :clearable="false"
                  placeholder="Choose destination"
                  :readonly="!is_general_manager || form.seats_assignment"
                  :error="$v.form.destination.$error"
                />
                <template #error>
                  <div v-if="$v.form.destination.$dirty && !$v.form.destination.required">Required field</div>
                </template>
              </app-form-group>
            </template>
            <template #col-1-5>
              <app-form-group label="Arrival" class="form-group--no-indent" required>
                <app-input
                  v-model="form.arrival"
                  v-mask="'99:99'"
                  placeholder="00:00"
                  autocomplete="off"
                  id="time"
                  name="time"
                  @paste.native.prevent
                  :readonly="!is_general_manager || form.seats_assignment"
                  :error="$v.form.arrival.$error"
                />
                <template #error>
                  <div v-if="$v.form.arrival.$dirty && !$v.form.arrival.timeRegex">Wrong time</div>
                  <div v-if="$v.form.arrival.$dirty && !$v.form.arrival.required">Required field</div>
                </template>
              </app-form-group>
            </template>
          </app-flex-grid>
          <app-cells v-if="is_general_manager && !form.seats_assignment" position="between" :indent="false">
            <app-cells :indent="false">
              <app-luggage-card
                @clickCard="onLuggageClick(card)"
                v-for="card in form.airline.luggage_options"
                :key="`card_${card.id}`"
                :age_type="card.age_type"
                :weight="card.weight"
                :disable="checkExistsInArray(seats_short, card)"
              />
            </app-cells>
            <app-button @click.native="onCheckUpdateFlight" type="submit" ref="submit_update">
              Save flight
            </app-button>
          </app-cells>
          <app-cells>
            <app-filters
              v-model="seats_filter"
              :filters="seats_filters"
              name="filterSeats"
            />
          </app-cells>

          <template v-if="seats_filter === 'seats'">
            <app-page-container v-if="seats.length" indent middle>
              <app-lug-item
                v-for="(lugage, lugage_index) in seats"
                :key="`lug_${lugage_index}`"
                @onChangeLugClients="onChangeLugClients($event, lugage_index)"
                :order-number="lugage_index + 1"
                :age-type="lugage.luggage_option.age_type"
                :weight="lugage.luggage_option.weight"
                :client-selected="lugage.client"
                :clients-options="clients_options"
                :seats-assignment="form.seats_assignment"
                :deleted="false"
              />
            </app-page-container>
            <app-no-results v-else text="There’s no luggage yet" small />
            <div v-if="form.sales_status.code === 'book' && !form.amendment_request" class="downloads">
              <div class="downloads__item" :class="{'downloads__item--loading': payment_completed_loader}">
                <div class="downloads__left">
                  <div class="downloads__info">
                    <span class="downloads__name downloads__name--no-events">Seats assignment completed</span>
                  </div>
                </div>
                <div class="downloads__right">
                  <div class="downloads__values">
                    <span class="downloads__key">Status:</span>
                    <app-switcher
                      :readonly="(!is_general_manager && !is_sales_manager && !is_sales_supervisor) && !form.lead?.client_group"
                      v-model="form.seats_assignment"
                      @change="onUpdateSeatsData(true)"
                    />
                  </div>
                  <template v-if="form.seats_assignment && form.seats_assignment_by && !payment_completed_loader">
                    <div class="downloads__values">
                      <span class="downloads__key">Completed at:</span>
                      <span class="downloads__value downloads__width">{{ dateTimeFormat(form.seats_assignment_at) }}</span>
                    </div>
                    <div class="downloads__values">
                      <span class="downloads__key">Completed by:</span>
                      <div class="downloads__person downloads__width">
                        <div class="downloads__photo">
                          <img :src="getUserAvatar(form.seats_assignment_by?.crop?.crop_url)" alt="Person">
                        </div>
                        <span class="downloads__value">{{ form.seats_assignment_by?.full_name || '-' }}</span>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <template v-if="seats_filter === 'seats_short'">
            <app-page-container v-if="seats_short.length" indent small>
              <app-lug-item
                v-for="(seat, seat_index) in seats_short"
                :key="`lug_${seat_index}`"
                @onDeleteLugItem="onShortRoomDelete(seat_index, 'seats_short')"
                @onCountInput="onCountChange($event, seat_index, 'seats_short')"
                :order-number="seat_index + 1"
                :age-type="seat.luggage_option.age_type"
                :weight="seat.luggage_option.weight"
                :count="seat.count"
                :seats-assignment="true"
                :deleted="is_general_manager"
              />
            </app-page-container>
            <app-no-results v-else text="There’s no luggage yet" small />
          </template>
        </template>
      </app-page-container>
      <app-tabs :tabs="tabs" />
      <transition name="fade" mode="out-in">
        <router-view :reservation="form" ref="childComponent" />
      </transition>
    </template>
    <modal
      name="manager"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('manager')" class="popup__close" type="button"></button>
        <div class="popup__title">Assign reservation manager</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckManagerForm">
            <app-form-group label="Reservation manager" required>
              <app-select
                v-model="manager.reservation_manager"
                :reduce="item => item.id"
                :options="managers_options"
                :clearable="false"
                label="full_name"
                placeholder="Choose manager"
                :error="$v.manager.reservation_manager.$error"
              />
              <template #error>
                <div v-if="$v.manager.reservation_manager.$dirty && !$v.manager.reservation_manager.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.manager.$error" type="submit" ref="submit_manager">Assign manager</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="accept-reservation-status"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('accept-reservation-status')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Change status
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to change status?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('accept-reservation-status')" theme="dark">Cancel</app-button>
            <app-button @click.native="onPatchReservationStatus" ref="patch_reservation_status">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="deadline"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div v-if="reservation_status_data" class="popup">
        <button @click="onHideDeadlinePopup" class="popup__close" type="button"></button>
        <div class="popup__title">
          {{ reservation_status_data.title }}
        </div>
        <div class="popup__body">
          <app-form-group v-if="reservation_status_data.reservation_status === 'booked_provisionally'" label="Deadline" required>
            <app-date-picker v-model="reservation_status_data.reservation_deadline" placeholder="Deadline" />
          </app-form-group>
          <app-form-group label="Additional message to sales" label-for="notes">
            <app-textarea
              v-model="reservation_status_data.additional_message"
              rows="5"
              placeholder="Write a message"
              id="notes"
            />
          </app-form-group>
          <app-cells position="center" :indent="false">
            <app-button @click.native="onPatchDeadline" ref="submit_deadline">Save</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="accept-request-cancellation-modal"
      :width="500"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('accept-request-cancellation-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Request full cancellation</div>
        <div class="popup__body">
          <div v-if="form.cancellation_rate" class="popup__subt">
            Cancellation fee <u>{{ form.cancellation_rate }}</u>% will apply for this reservation.<br> This request will be sent to the reservations department to process the cancellation manually.<br> You can provide additional notes for the flight below.
          </div>
          <div v-else class="popup__subt">
            Cancellation fees will not apply for this reservation, and we will automatically send an email to the airline. You can provide additional notes below.
          </div>
          <app-form-group
            label="Sales manager notes for hotel cancellation"
            label-for="notes"
          >
            <app-textarea
              v-model="notes_cancellation"
              rows="5"
              placeholder="Write a note"
              id="notes"
            />
          </app-form-group>
          <app-cells position="center" :indent="false">
            <app-button @click.native="onRequestCancellation" ref="request_cancellation">Request</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="send-email-popup"
      :width="450"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('send-email-popup')" class="popup__close" type="button"></button>
        <div class="popup__title">Send {{ current_action }} email</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckSendEmailForm">
<!--            <app-form-group label="Communication email">-->
<!--              <template #additional>-->
<!--                <img-->
<!--                  v-if="form?.airline?.emails_reservation.length > 1"-->
<!--                  src="@/assets/img/warning-icon.svg"-->
<!--                  alt="Confirmed"-->
<!--                  v-tooltip="{ content: 'If the communication email is not chosen, we will send emails to all hotel addresses', placement: 'top', offset: 10 }"-->
<!--                >-->
<!--              </template>-->
<!--              <app-select-->
<!--                v-model="form_send_email.communication_email"-->
<!--                :options="form?.airline?.emails_reservation"-->
<!--                :readonly="form?.airline?.emails_reservation && form?.airline?.emails_reservation.length === 1"-->
<!--                label="email"-->
<!--                placeholder="Choose email"-->
<!--              >-->
<!--              </app-select>-->
<!--            </app-form-group>-->
            <app-form-group label="Template" required>
              <app-select
                v-model="form_send_email.email_template"
                :options="email_templates"
                :clearable="false"
                :get-option-label="item => item.sendpulse_template.name"
                :display-field="option => option.sendpulse_template.name"
                placeholder="Choose template"
                :error="$v.form_send_email.email_template.$error"
              />
              <template #error>
                <div v-if="$v.form_send_email.email_template.$dirty && !$v.form_send_email.email_template.required">Required field</div>
              </template>
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button type="submit" ref="send_email_submit" :disabled="$v.form_send_email.$error">
                Send
              </app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="cancellation-reservation-accept"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onCloseAcceptCancellationReservation" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Change status
        </div>
        <div class="popup__body">
          <div class="popup__subt">
            Are you sure you want to change status to {{ current_cancellation_status.name?.toUpperCase() }}?
          </div>
          <app-form-group
            v-if="current_cancellation_status && current_cancellation_status.amount_required"
            label="Amount (USD)"
            label-for="cancellation_amount"
            required
          >
            <app-fin-number
              v-model="cancellation_amount"
              id="cancellation_amount"
              placeholder="0"
              name="cancellation_amount"
              :error="$v.cancellation_amount.$error"
            />
            <template #error>
              <div v-if="$v.cancellation_amount.$dirty && !$v.cancellation_amount.required">Required field</div>
            </template>
          </app-form-group>
          <app-cells position="center" :indent="false">
            <app-button @click.native="onCloseAcceptCancellationReservation" theme="dark">Cancel</app-button>
            <app-button
              @click.native="onCheckCancellationReservationStatusForm"
              ref="cancellation_reservation_status"
              :disabled="$v.cancellation_amount.$error"
            >
              Yes
            </app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="accept-delete-res"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('accept-delete-res')" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Delete flight reservation
        </div>
        <div class="popup__body">
          <div class="popup__subt">Are you sure you want to delete this reservation?</div>
          <app-cells position="center" :indent="false">
            <app-button @click.native="$modal.hide('accept-delete-res')" theme="dark">Cancel</app-button>
            <app-button @click.native="onDeleteFlightReservation" ref="delete_flight_res">Yes</app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="amendment-reservation-accept"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="onCloseAcceptAmendmentReservation" class="popup__close" type="button"></button>
        <div class="popup__title popup__title--flex">
          <img src="@/assets/img/warning-round-icon.svg" alt="">
          Change status
        </div>
        <div class="popup__body">
          <div class="popup__subt">
            Are you sure you want to change status to {{ current_amendment_status.name?.toUpperCase() }}?
          </div>
          <app-form-group
            v-if="current_amendment_status && current_amendment_status.amount_required"
            label="Amount (USD)"
            label-for="cancellation_amount"
            required
          >
            <app-fin-number
              v-model="amendment_amount"
              id="cancellation_amount"
              placeholder="0"
              name="cancellation_amount"
              :error="$v.amendment_amount.$error"
            />
            <template #error>
              <div v-if="$v.amendment_amount.$dirty && !$v.amendment_amount.required">Required field</div>
            </template>
          </app-form-group>
          <app-cells position="center" :indent="false">
            <app-button @click.native="onCloseAcceptAmendmentReservation" theme="dark">Cancel</app-button>
            <app-button
              @click.native="onCheckAmendmentReservationStatusForm"
              ref="amendment_reservation_status"
              :disabled="$v.amendment_amount.$error"
            >
              Yes
            </app-button>
          </app-cells>
        </div>
      </div>
    </modal>
    <modal
      name="request-amendment-modal"
      :width="930"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      class="modal-not-overflow"
      draggable=".popup__title"
      :reset="true"
    >
      <div class="popup">
        <button @click="$modal.hide('request-amendment-modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Request amendment</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckRequestAmendment">
            <h3 class="title title--mb15">Flight configuration</h3>
            <div class="reservation-grid__main">
              <app-cells :indent="false">
                <app-form-group label="Date" required>
                  <app-date-picker
                    v-model="form_request_amendment.date"
                    placeholder="Date"
                    class="datepicker--filter"
                    :error="$v.form_request_amendment.date.$error"
                  />
                  <template #error>
                    <div v-if="$v.form_request_amendment.date.$dirty && !$v.form_request_amendment.date.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Origin" required>
                  <app-select
                    v-model="form_request_amendment.origin"
                    :options="form?.airline?.airstrips"
                    :clearable="false"
                    placeholder="Choose origin"
                    class="select--200"
                    :error="$v.form_request_amendment.origin.$error"
                  />
                  <template #error>
                    <div v-if="$v.form_request_amendment.origin.$dirty && !$v.form_request_amendment.origin.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Destination" required>
                  <app-select
                    v-model="form_request_amendment.destination"
                    :options="form?.airline?.airstrips"
                    :clearable="false"
                    placeholder="Choose destination"
                    class="select--200"
                    :error="$v.form_request_amendment.destination.$error"
                  />
                  <template #error>
                    <div v-if="$v.form_request_amendment.destination.$dirty && !$v.form_request_amendment.destination.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Departure" required>
                  <app-input
                    v-model="form_request_amendment.departure"
                    v-mask="'99:99'"
                    placeholder="00:00"
                    autocomplete="off"
                    class="input--100"
                    id="time"
                    name="time"
                    @paste.native.prevent
                    :error="$v.form_request_amendment.departure.$error"
                  />
                  <template #error>
                    <div v-if="$v.form_request_amendment.departure.$dirty && !$v.form_request_amendment.departure.timeRegex">Wrong time</div>
                    <div v-if="$v.form_request_amendment.arrival.$dirty && !$v.form_request_amendment.arrival.required">Required field</div>
                  </template>
                </app-form-group>
                <app-form-group label="Arrival" required>
                  <app-input
                    v-model="form_request_amendment.arrival"
                    v-mask="'99:99'"
                    placeholder="00:00"
                    autocomplete="off"
                    class="input--100"
                    id="time"
                    name="time"
                    @paste.native.prevent
                    :error="$v.form_request_amendment.arrival.$error"
                  />
                  <template #error>
                    <div v-if="$v.form_request_amendment.arrival.$dirty && !$v.form_request_amendment.arrival.timeRegex">Wrong time</div>
                    <div v-if="$v.form_request_amendment.arrival.$dirty && !$v.form_request_amendment.arrival.required">Required field</div>
                  </template>
                </app-form-group>
              </app-cells>
            </div>
            <app-cells :indent="false">
              <app-luggage-card
                @clickCard="onLuggageAmendmentClick(card)"
                v-for="card in form?.airline?.luggage_options"
                :key="`card_${card.id}`"
                :age_type="card.age_type"
                :weight="card.weight"
                :disable="checkExistsInArrayAmendment(card)"
              />
            </app-cells>
            <template v-if="form_request_amendment.reservation_rooms.length">
              <h3 class="title title--mb15">Seats</h3>
              <app-lug-item
                v-for="(lugage, lugage_index) in form_request_amendment.reservation_rooms"
                :key="`lug_${lugage_index}`"
                @onDeleteLugItem="onShortRoomAmendmentDelete(lugage_index)"
                @onCountInput="onCountAmendmentChange($event, lugage_index)"
                :orderNumber="lugage_index + 1"
                :ageType="lugage.luggage_option.age_type"
                :weight="lugage.luggage_option.weight"
                :count="lugage.count"
              />
            </template>
            <div v-else class="no-results no-results--small no-results--margin">
              <div class="no-results__title">No Results</div>
              <div class="no-results__text">There’s no luggage yet</div>
            </div>
            <app-form-group
              label="Additional notes for the airline"
              label-for="notes"
              style="margin-top: 20px;"
            >
              <app-textarea
                v-model="form_request_amendment.notes"
                rows="5"
                placeholder="Write a note"
                id="notes"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button :disabled="$v.form_request_amendment.$error" type="submit" ref="request_amendment">Request</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  deleteReservationsFlights,
  getReservationsEmailTemplate,
  getReservationsFlight,
  getReservationsFlightsClients,
  getUsers,
  patchLead,
  patchReservationsFlightAmendmentRequest,
  patchReservationsFlightCancellationRequest,
  patchReservationsFlights,
  postReservationsFlightAmendmentRequest,
  postReservationsFlightCancellationRequest,
  postReservationsFlightsAmendmentRequestsEmail,
  postReservationsFlightsCancellationRequestsEmail,
  postReservationsFlightsEmail
} from '@/http'
import { helpers, required, requiredIf } from 'vuelidate/lib/validators'
import AppTabs from '@/components/AppTabs'
import { format, parse, parseISO } from 'date-fns'
import AppInfoTextPanel from '@/components/AppInfoTextPanel.vue'
import AppOptionPicker from '@/components/AppOptionPicker.vue'
import AppLugItem from '@/components/AppLugItem.vue'
import AppColoredNotes from '@/components/AppColoredNotes.vue'
import AppLuggageCard from '@/components/AppLuggageCard.vue'

const timeRegex = helpers.regex('timeRegex', /^([0-1][0-9]|2[0-3]):([0-5][0-9])?$/i)

export default {
  name: 'FlightsReservationsLayout',
  components: { AppLuggageCard, AppColoredNotes, AppLugItem, AppOptionPicker, AppInfoTextPanel, AppTabs },
  data() {
    return {
      is_loaded: false,
      tabs: [
        { name: 'reservation-flights-general', label: 'General' },
        { name: 'reservation-flights-finance', label: 'Finance' },
        { name: 'reservation-flights-finance-old', label: 'Finance Old' },
        { name: 'reservation-flights-emails', label: 'Emails' },
        { name: 'reservation-flights-history', label: 'History' },
      ],
      form: { reservation_rooms: [] },
      placement: 'bottom',
      admin_url: process.env.VUE_APP_ADMIN_URL,
      manager: {},
      managers_options: [],
      reservation_status_data: null,
      reservation_deadline: null,
      seats: [],
      seats_short: [],
      flight_from_options: [],
      flight_to_options: [],
      airline_options: [],
      schedule_options: [],
      payment_completed_loader: false,
      notes_cancellation: '',
      email_templates: [],
      current_action: '',
      form_send_email: {},
      current_cancellation_status: {},
      current_amendment_status: {},
      cancellation_amount: null,
      amendment_amount: null,
      seats_filter: 'seats_short',
      seats_filters: [
        { value: 'seats_short', label: 'Short summary' },
        { value: 'seats', label: 'Seats assignment' },
      ],
      form_request_amendment: {
        reservation_rooms: [],
      },
      clients_options: []
    }
  },
  validations: {
    form: {
      date: { required },
      origin: { required },
      destination: { required },
      departure: { timeRegex },
      arrival: { required, timeRegex }
    },
    manager: {
      reservation_manager: { required }
    },
    form_send_email: {
      email_template: { required },
    },
    cancellation_amount: {
      required: requiredIf(function() {
        return this.current_cancellation_status && this.current_cancellation_status.amount_required
      }),
    },
    form_request_amendment: {
      date: { required },
      origin: { required },
      destination: { required },
      departure: { timeRegex },
      arrival: { required, timeRegex }
    },
    amendment_amount: {
      required: requiredIf(function() {
        return this.current_amendment_status && this.current_amendment_status.amount_required
      }),
    },
  },
  computed: {
    is_general_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('general_manager')
    },
    is_sales_manager() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_sales_supervisor() {
      return this.$store.state.userGroups.map(item => item.code).includes('sales_manager')
    },
    is_reservations_department() {
      return this.$store.state.userGroups.map(item => item.code).includes('reservation_manager')
        || this.$store.state.userGroups.map(item => item.code).includes('reservation_assistant')
        || this.$store.state.userGroups.map(item => item.code).includes('reservation_supervisor')
    },
    is_super_user() {
      return this.$store.state.userData.is_superuser
    },
  },
  created() {
    this.getReservationData()
    if (this.is_general_manager || this.is_reservations_department) {
      getUsers({ group: 'reservation_supervisor,reservation_manager,reservation_assistant', is_active: true })
        .then(response => { this.managers_options = response.data })
    }
  },
  methods: {
    onCheckAmendmentReservationStatusForm() {
      this.$v.amendment_amount.$touch()
      if (this.$v.amendment_amount.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.changeAmendmentReservationStatus()
      }
    },
    changeAmendmentReservationStatus() {
      this.$refs.amendment_reservation_status.preload = true
      patchReservationsFlightAmendmentRequest(
        this.form.amendment_request.id,
        { reservation_status: this.current_amendment_status.code, amount: this.amendment_amount }
      )
        .finally(() => { this.$refs.amendment_reservation_status.preload = false })
        .then(() => {
          this.getReservationData()
          this.$modal.hide('amendment-reservation-accept')
        })
    },
    onPatchReservationAmendmentNotes() {
      patchReservationsFlightAmendmentRequest(
        this.form.amendment_request.id,
        { notes: this.form.amendment_request.notes }
      )
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved',
          })
        })
    },
    onCloseAcceptAmendmentReservation() {
      this.is_loaded = false
      this.$modal.hide('amendment-reservation-accept')
      this.getReservationData()
    },
    onAmendmentOptionSelected(event, is_reservation) {
      this.current_amendment_status = event
      if (is_reservation) this.$modal.show('amendment-reservation-accept')
      else this.changeAmendmentSalesStatus()
    },
    changeAmendmentSalesStatus() {
      patchReservationsFlightAmendmentRequest(
        this.form.amendment_request.id,
        { sales_status: this.current_amendment_status.code }
      )
        .then(() => { this.getReservationData() })
    },
    checkExistsInArrayAmendment(obj) {
      return this.form_request_amendment.reservation_rooms.some(element => {
        const { ...restElement } = element.luggage_option
        const { ...restObj } = obj

        return JSON.stringify(restElement) === JSON.stringify(restObj)
      })
    },
    onCheckRequestAmendment() {
      this.$v.form_request_amendment.$touch()
      if (this.$v.form_request_amendment.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly'
        })
      } else {
        this.sendRequestAmendment()
      }
    },
    sendRequestAmendment() {
      this.$refs.request_amendment.preload = true
      postReservationsFlightAmendmentRequest(this.normalizeRequestAmendmentForm())
        .finally(() => { this.$refs.request_amendment.preload = false })
        .then(() => {
          this.getReservationData()
          this.$notify({
            type: 'success',
            title: 'Request has been sent',
          })
          this.$modal.hide('request-amendment-modal')
        })
    },
    normalizeRequestAmendmentForm() {
      const form = { ...this.form_request_amendment }

      form.reservation = +this.$route.params.id
      form.sales_status = 'change'
      form.destination = this.form_request_amendment.destination.id
      form.origin = this.form_request_amendment.origin.id
      form.departure = `${this.form_request_amendment.departure}:00`
      form.arrival = `${this.form_request_amendment.arrival}:00`
      form.notes = this.form_request_amendment.notes
      form.short_seats = this.form_request_amendment.reservation_rooms
        .map(item => {
          return {
            original_short_seat: item?.id,
            luggage_option: item.luggage_option.id,
            count: item.count,
          }
        })
      delete form.reservation_rooms

      return form
    },
    onShowRequestAmendmentsModal() {
      this.form_request_amendment = {
        reservation_rooms: this.seats_short,
        date: this.form.date,
        origin: this.form.origin,
        destination: this.form.destination,
        departure: this.form.departure,
        arrival: this.form.arrival,
      }

      this.$v.form_request_amendment.$reset()
      this.$modal.show('request-amendment-modal')
    },
    onDeleteFlightReservation() {
      this.$refs.delete_flight_res.preload = true
      deleteReservationsFlights(this.$route.params.id)
        .finally(() => { this.$refs.delete_flight_res.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Reservation deleted',
          })
          this.$modal.hide('accept-delete')
          this.$router.push({ name: 'reservation-flights-list' })
        })
    },
    onCheckUpdateFlight() {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly'
        })
      } else {
        this.sendUpdateFlightForm()
      }
    },
    sendUpdateFlightForm() {
      this.$refs.submit_update.preload = true
      patchReservationsFlights(this.$route.params.id, this.normalizeUpdateFlightForm())
        .finally(() => { this.$refs.submit_update.preload = false })
        .then(() => {
          this.getReservationData()
          this.$notify({
            type: 'success',
            title: 'Reservation updated',
          })
        })
    },
    normalizeUpdateFlightForm() {
      const form = {}

      form.date = this.form.date
      form.origin = this.form.origin.id
      form.destination = this.form.destination.id
      form.departure = `${this.form.departure}:00`
      form.arrival = `${this.form.arrival}:00`
      form.seats_short = this.seats_short.map(item => ({ id: item.id, count: item.count, luggage_option: item.luggage_option.id }))

      return form
    },
    checkExistsInArray(array, obj) {
      return array.some(element => {
        const { ...restElement } = element.luggage_option
        const { ...restObj } = obj

        return JSON.stringify(restElement) === JSON.stringify(restObj)
      })
    },
    onLuggageClick(luggage) {
      if (this.seats_filter !== 'seats_short') this.seats_filter = 'seats_short'
      this.seats_short.push({ luggage_option: luggage, count: 1 })
    },
    onLuggageAmendmentClick(luggage) {
      this.form_request_amendment.reservation_rooms.push({ luggage_option: luggage, count: 1 })
    },
    onShortRoomDelete(index, targetObj) {
      this[targetObj].splice(index, 1)
    },
    onShortRoomAmendmentDelete(index) {
      this.form_request_amendment.reservation_rooms.splice(index, 1)
    },
    onCountChange(count, index, targetObj) {
      this[targetObj][index].count = +count
    },
    onCountAmendmentChange(count, index) {
      this.form_request_amendment.reservation_rooms[index].count = count
    },
    onPatchReservationCancellationNotes() {
      patchReservationsFlightCancellationRequest(
        this.form.cancellation_request.id,
        { notes: this.form.cancellation_request.notes }
      )
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved',
          })
          this.getReservationData()
        })
    },
    onCheckCancellationReservationStatusForm() {
      this.$v.cancellation_amount.$touch()
      if (this.$v.cancellation_amount.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.changeCancellationReservationStatus()
      }
    },
    changeCancellationReservationStatus() {
      this.$refs.cancellation_reservation_status.preload = true
      patchReservationsFlightCancellationRequest(
        this.form.cancellation_request.id,
        { reservation_status: this.current_cancellation_status.code, amount: this.cancellation_amount }
      )
        .finally(() => { this.$refs.cancellation_reservation_status.preload = false })
        .then(() => {
          this.getReservationData()
          this.$modal.hide('cancellation-reservation-accept')
        })
    },
    onCloseAcceptCancellationReservation() {
      this.is_loaded = false
      this.$modal.hide('cancellation-reservation-accept')
      this.getReservationData()
    },
    changeCancellationSalesStatus() {
      patchReservationsFlightCancellationRequest(
        this.form.cancellation_request.id,
        { sales_status: this.current_cancellation_status.code }
      )
        .then(() => { this.getReservationData() })
    },
    onCancellationOptionSelected(event, is_reservation) {
      this.current_cancellation_status = event
      if (is_reservation) this.$modal.show('cancellation-reservation-accept')
      else this.changeCancellationSalesStatus()
    },
    onCheckSendEmailForm() {
      this.$v.form_send_email.$touch()
      if (this.$v.form_send_email.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendEmailForm()
      }
    },
    sendEmailForm() {
      this.$refs.send_email_submit.preload = true
      if (this.current_action === 'amendment') {
        postReservationsFlightsAmendmentRequestsEmail(this.form.amendment_request.id, this.normalizeEmailForm())
          .finally(() => { this.$refs.send_email_submit.preload = false })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Reservation email sent',
            })
            this.$refs.childComponent.getReservationsEmailsList()
            this.$modal.hide('send-email-popup')
          })
      } else {
        postReservationsFlightsCancellationRequestsEmail(this.form.cancellation_request.id, this.normalizeEmailForm())
          .finally(() => { this.$refs.send_email_submit.preload = false })
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Reservation email sent',
            })
            this.$refs.childComponent.getReservationsEmailsList()
            this.$modal.hide('send-email-popup')
          })
      }
    },
    normalizeEmailForm() {
      const normalizedForm = { ...this.form_send_email }

      if (normalizedForm.communication_email) normalizedForm.communication_email = normalizedForm.communication_email.id
      if (normalizedForm.email_template) normalizedForm.email_template = normalizedForm.email_template.id

      return normalizedForm
    },
    onOpenSendEmailPopup(type) {
      this.current_action = type
      getReservationsEmailTemplate({
        category: type,
        type: 'flight',
        [`${type}_request_sales_statuses`]: this.form[`${type}_request`].sales_status.code,
        [`${type}_request_statuses`]: this.form[`${type}_request`].reservation_status.code,
      })
        .then(res => {
          this.email_templates = res.data
          if (this.email_templates.length === 1) {
            this.form_send_email = { email_template: this.email_templates[0] }
          }
          this.$v.form_send_email.$reset()
          this.$modal.show('send-email-popup')
        })
    },
    onRequestCancellation() {
      this.$refs.request_cancellation.preload = true
      postReservationsFlightCancellationRequest(
        {
          reservation: +this.$route.params.id,
          sales_status: this.form.cancellation_rate ? 'cancel_manually' : 'cancel',
          notes: this.notes_cancellation || null
        }
      )
        .finally(() => { this.$refs.request_cancellation.preload = false })
        .then(() => {
          this.$modal.hide('accept-request-cancellation-modal')
          this.getReservationData()
        })
    },
    onPatchReservationNotes() {
      patchReservationsFlights(this.$route.params.id, { notes: this.form.notes })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Data saved',
          })
        })
    },
    onUpdateSeatsData(loader = false) {
      if (loader) this.payment_completed_loader = true
      patchReservationsFlights(
        this.$route.params.id,
        {
          seats: this.seats.map(item => ({ id: item.id, client: item.client ? item.client.id : null })),
          seats_assignment: this.form.seats_assignment
        }
      )
        .then(() => {
          this.getReservationData()
          this.$notify({
            type: 'success',
            title: 'Change saved',
          })
          if (loader) this.payment_completed_loader = false
        })
        .catch(() => {
          this.form.seats_assignment = false
          if (loader) this.payment_completed_loader = false
        })
    },
    onChangeLugClients(client, index) {
      this.seats[index].client = client
    },
    onChangeLugAmendmentClients(client, index) {
      this.form_request_amendment.reservation_rooms[index].client = client
    },
    onOptionSelected(e, deadline) {
      const data_reservation = {
        reservation_status: e.code,
        title: e.name,
        additional_message: ''
      }
      const data_sales = { sales_status: e.code }
      if (e.code === 'booked_provisionally') data_reservation.reservation_deadline = null
      this.onShowAcceptReservationStatusPatch(deadline ? data_reservation : data_sales, deadline)
    },
    onShowAcceptReservationStatusPatch(data, deadline) {
      this.reservation_status_data = data
      if (!deadline) this.onPatchReservationStatus()
      else this.$modal.show('deadline')
    },
    onChangeEarlyCheckInTime(time, index) {
      this.form.reservation_rooms[index].early_check_in_time = time
    },
    onChangeLateCheckOutTime(time, index) {
      this.form.reservation_rooms[index].late_check_out_time = time
    },
    onPatchDeadline() {
      this.$refs.submit_deadline.preload = true
      patchReservationsFlights(
        this.$route.params.id,
        {
          reservation_status: this.reservation_status_data.reservation_status,
          reservation_deadline: this.reservation_status_data.reservation_deadline || null,
          additional_message: this.reservation_status_data.additional_message,
        }
      )
        .finally(() => { this.$refs.submit_deadline.preload = false })
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Status changed',
          })
          this.$modal.hide('deadline')
          this.getReservationData()
        })
    },
    onPatchReservationStatus() {
      patchReservationsFlights(this.$route.params.id, this.reservation_status_data)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Status changed',
          })
          this.getReservationData()
        })
    },
    onCheckManagerForm() {
      this.$v.manager.$touch()
      if (this.$v.manager.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this.sendManagerForm()
      }
    },
    sendManagerForm() {
      this.$refs.submit_manager = true
      patchLead(this.form.lead.id, this.manager)
        .finally(() => { this.$refs.submit_manager = false })
        .then(() => {
          this.getReservationData()
          this.$modal.hide('manager')
          this.$notify({
            type: 'success',
            title: 'Reservation manager saved',
          })
        })
    },
    onHideDeadlinePopup() {
      this.is_loaded = false
      this.$modal.hide('deadline')
      this.getReservationData()
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    onRoomDelete(index, form) {
      this[form].reservation_rooms.splice(index, 1)
    },
    getReservationData() {
      getReservationsFlight(this.$route.params.id)
        .then(res => {
          this.form = res.data
          document.title = `${this.form.airline.name} (#${this.$route.params.id}) | Altezza Board`
          this.seats = [ ...res.data.seats ]
          this.seats_short = [ ...res.data.seats_short ]
          this.is_loaded = true

          if (this.form.lead?.client_group?.id) {
            getReservationsFlightsClients(
              this.form.lead.client_group.id,
              { airline_id: this.form.airline.id, date: this.form.date }
            )
              .then(res => { this.clients_options = res.data })
          }
        })
    },
    dateFormat(date) {
      return date ? format(parse(date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : '-'
    },
    onCopyToClipboard(string) {
      navigator.clipboard.writeText(string)
        .then(() => {
          this.$notify({
            type: 'success',
            title: 'Copied to clipboard',
          })
        })
        .catch(() => { console.error('Something went wrong') })
    },
    dateTimeFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy HH:mm') : '-'
    },
    formatDate(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : '-'
    },
  }
}
</script>

<style lang="sass" scoped>
// ------------------------- amendment-info
.amendment-info
  margin-top: 20px
  margin-bottom: 20px
  padding: 8px 10px
  border: 1px solid #ffa51f

  p
    color: #404040
    font-size: 12px
    line-height: 18px

  b
    font-weight: 500

.amendment-info__top
  display: flex
  align-items: center
  gap: 10px
  margin-bottom: 15px

.amendment-info__status
  padding: 3px 7px 2px
  border-radius: 20px
  color: #fff
  font-weight: 600

.amendment-info__grid
  display: grid
  grid-template-columns: repeat(3, 1fr)
  max-width: 900px

.amendment-info__item
  display: flex
  align-items: center
  gap: 5px
  margin-bottom: 10px

.amendment-info__key
  color: #404040

.amendment-info__val
  font-weight: 500

// ------------------------- reservation-grid
.reservation-grid__row
  display: grid
  gap: 20px
  margin-bottom: 20px

  &:last-child
    margin-bottom: 0

.reservation-grid__row--mix
  grid-template-columns: 1fr 120px 170px 170px 60px

//.reservation-grid__main
//  padding-bottom: 20px

.reservation-grid__row--top
  grid-template-columns: 1fr 170px

.reservation-grid__row--triple
  grid-template-columns: 180px 130px 130px

.reservation-grid__row--quartet
  grid-template-columns: 130px 130px 50px 1fr
  align-items: center

.reservation-grid__row--single
  grid-template-columns: 206px 100px

.reservation-grid__row--double
  grid-template-columns: repeat(2, 1fr)

.reservation-grid__room-list
  display: grid
  grid-template-columns: repeat(2, 1fr)
  gap: 0 15px
  margin-bottom: 20px

.reservation-grid__rooms
  padding-top: 25px

.reservation-grid__types-list
  display: flex
  justify-content: flex-start
  align-items: center
  flex-wrap: wrap
  gap: 10px
  padding-top: 20px

.reservation-grid__room
  margin-bottom: 15px

.reservation-grid__title
  margin-bottom: 15px

.reservation-grid__clients
  margin-bottom: 15px

.reservation-grid__clients-list
  display: flex
  align-items: center
  flex-wrap: wrap
  gap: 10px 20px
  margin-top: 10px
  padding: 20px
  border: 1px solid #ebebeb
  border-radius: 9px
  background-color: #fdfdfd

.reservation-grid__client
  display: flex
  align-items: center
  gap: 6px
  width: 145px

  span
    padding-top: 2px

.lug-items-wrapper
  display: grid
  grid-template-columns: repeat(2, 1fr)
  gap: 0 15px

.reservation-grid--request
  .reservation-grid__rooms
    padding-top: 20px

  .reservation-grid__row
    display: grid
    gap: 20px
    margin-bottom: 20px

    &:last-child
      margin-bottom: 0

  .reservation-grid__luggage
    display: flex
    justify-content: flex-start
    align-items: center
    flex-wrap: wrap
    gap: 15px
    margin-bottom: 15px

  .reservation-grid__row--quartet
    grid-template-columns: 180px 160px 70px 1fr
    align-items: center

  .flights-selection__card
    position: relative
    display: flex
    justify-content: flex-start
    align-items: center
    gap: 10px
    margin-bottom: 10px
    padding: 10px
    border: 1px solid #dcdcdc
    border-radius: 10px
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08)
    background-color: #fff
    cursor: pointer
    transition: border-color 0.3s

    &:hover
      border-color: #b8b8b8

  .flights-selection__icon
    display: inline-flex
    align-items: flex-end
    justify-content: center
    gap: 2px
    min-width: 38px
    height: 38px
    padding: 8px
    border: 1px solid rgba(0, 0, 0, 0.1)
    border-radius: 4px
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1)
    background: linear-gradient(180deg, #fff 0%, #f4f4f4 100%)
    transition: border 0.3s, background-color 0.3s

  .flights-selection__text
    font-weight: 500

  .flights-selection__price
    position: absolute
    right: 10px
    top: 50%
    transform: translateY(-50%)
    font-weight: 500

.downloads
  margin-bottom: 20px
</style>
